export default function waitForYm(timeoutMs = 10000, stepMs = 50) {
  return new Promise<void>((resolve, reject) => {
    const start = Date.now();
    const id = setInterval(() => {
      if (window.ym) {
        clearInterval(id);
        resolve();
      }
      if (Date.now() - start > timeoutMs) {
        clearInterval(id);
        reject(new Error('ym not available within timeout'));
      }
    }, stepMs);
  });
}
